import { render, staticRenderFns } from "./CAA.vue?vue&type=template&id=c61d64e6&"
import script from "./CAA.vue?vue&type=script&lang=js&"
export * from "./CAA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports